import { render, staticRenderFns } from "./TopCenter.vue?vue&type=template&id=38cde4a8&scoped=true"
import script from "./TopCenter.vue?vue&type=script&lang=ts"
export * from "./TopCenter.vue?vue&type=script&lang=ts"
import style0 from "./TopCenter.vue?vue&type=style&index=0&id=38cde4a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cde4a8",
  null
  
)

export default component.exports